import { PageFlagDefinition } from '../types/page';

// ALL ID's ARE AUTOMATICALLY PREFIXED WITH "page." DURING POST PROCESSING
const defaultPageFlags: PageFlagDefinition[] = [
  {
    id: 'insights',
    name: 'Insights',
    enabled: false,
    description: 'The dashboard page',
    parent: {
      id: 'role.internalUser',
    },
  },
  {
    id: 'consentDashboard.sitemap',
    name: 'Consent Dashboard - Sitemap',
    enabled: false,
    description: 'Allows access to the sitemap section of the consent dashboard',
    parent: {
      id: 'role.internalUser',
    },
  },
  {
    id: 'consentDashboard.tagVersions',
    name: 'Consent Dashboard - Tag Versions',
    enabled: false,
    description: 'Allows access to the tag versions section of the consent dashboard',
    parent: {
      id: 'role.internalUser',
    },
  },
];

export default defaultPageFlags;
